import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=2e20375d&lang=pug&"
import script from "./address-form.vue?vue&type=script&lang=js&"
export * from "./address-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports